module.exports = __webpack_public_path__ + "static/img/yellow-bg.d0b9fb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/yellow-bg.png
// module id = vYb3
// module chunks = 0